<template>
  <module-list-layout :createAction="createAction"
                      :headerActionClass="(userUsingPrivateRate)? 'voip-call-test-status pending p-2 border-0' : 'voip-call-test-status awaiting-action p-2 border-0' "
                      :headerActionText="(userUsingPrivateRate)? 'Create Private Rate' : 'Create Default Rate'"
                      :headerActionTranslate="false"
                      :module="module"
                      :title="customerDisplayName + ' Rates ' + userRateStatus"
                      class="p-2 border-0"
                      headerActionType="info"
                      style="box-shadow: none" v-if="amReady">

    <el-dialog :append-to-body="true" :visible.sync="dialogVisible" title="" top="5vh" width="75%" @close="reloadList">
      <moduleForm
          :bindingForView="true"
          :customerUserId="customerUserId"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="'Add Rate to ' + customerDisplayName"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :userUsingPrivateRate="userUsingPrivateRate == 1"
          v-if="dialogVisible"></moduleForm>

      <uploadDocumentRate :editMode="false" :customerUserId="customerUserId" :customerDisplayName="customerDisplayName" :userUsingPrivateRate="userUsingPrivateRate == 1"
            v-if="!editMode"></uploadDocumentRate>
    </el-dialog>


    <div class="row pl-3 pr-3 mt-4">
      <!--<div class="col-12 col-md-6 pt-1">
        <dg-text-field
            :field_span="19"
            :label_span="24"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search here"></dg-text-field>
      </div>-->
      <div class="col-12 col-md-6 pt-1">
        <pagination
            :currentPage="currentPage"
            :margin-pages="2"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            :page-range="4"
            paginateClass=""></pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>
import Vue from 'vue'
import actionsCell from './ag-grid/ActionsCell'
import isRateActive from './ag-grid/IsRateActive.vue'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";

export default {
  components: {
    uploadDocumentRate: () => import('./../../upload-document-rate/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    customerUserId: {
      required: true
    },
    customerDisplayName: {
      required: true
    },
    userRateStatus: {
      required: true
    },
    userUsingPrivateRate: {
      required: true
    }
  },
  data() {
    return {
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'vendor',
            headerName: 'Vendor',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'rate',
            headerName: 'Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'isActive',
            headerName: 'Active',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: Vue.extend(isRateActive),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    reloadList () {
      this.getEntityListData(this.currentPage)
    },
    ...mapActions('voip-customer-rate-api', {
      updateCustomerRate: 'update'
    }),
    setIsRateActive(params) {
      let data = {
        is_active: (params.value == true) ? 1 : 0,
      }
      this.updateCustomerRate({data, id: params.id})
    },
    getEntityListData(page) {
      let data = {page: page, search: this.userSearch}
      if (this.userUsingPrivateRate) {
        data.customerUserId = this.customerUserId
      }

      this.getEntityList(data).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...mapActions('voip-customer-rate-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-customer-rate->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-customer-rate->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
